<template>
  <div v-if="this.default && this.minDate && this.maxDate">
    <label>{{ $t("filter.titles." + key) }}</label>
    <b-input-group>
      <b-input-group-text>
        <font-awesome-icon :icon="icon" />
      </b-input-group-text>
      <date-picker
        v-model="selected"
        @input="transmitNewValue()"
        :config="options"
      />
    </b-input-group>
  </div>
</template>

<script>
export default {
  props: {
    default: { type: String, required: true },
    minDate: { type: String, required: true },
    maxDate: { type: String, required: true }
  },
  data() {
    return {
      options: {
        format: "MMMM YYYY",
        minDate: "",
        maxDate: ""
      },
      selected: "",
      icon: "calendar",
      key: "period"
    };
  },
  created() {
    this.options.minDate = this.minDate;
    this.options.maxDate = this.maxDate;
    this.transmitNewValue();
  },
  methods: {
    onContext(ctx) {
      this.selected = ctx.selectedYMD;
    },
    getDefaultPeriod() {
      const today = new Date();
      const defaultDate =
        today.getMonth() +
        1 +
        "-" +
        +today.getDate() +
        "-" +
        today.getFullYear();

      this.selected = defaultDate;
    },
    transmitNewValue() {
      this.$emit("transmit", this.selected, this.key);
    }
  }
};
</script>
<style scoped>
button {
  visibility: visible;
}
</style>
